import React from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import UnauthorizedLayout from '../UnauthorizedLayout'
import AuthService from '../../../services/AuthService'
import FormInput from '../../ui/FormInput'
import FormButton from '../../ui/FormButton'
import useNotification from '../../../hooks/useNotification'

const ForgotPassword = () => {
  const { t } = useTranslation('auth')
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm()

  const { info, error: showError } = useNotification()

  const navigate = useNavigate()

  const onSubmit = async (data) => {
    try {
      await AuthService.forgotPassword(data.email)
      // messaggio tradotto: il backend risponde con testo inglese hardcoded
      info(t('forgotPassword.toast.success'))
    } catch (e) {
      console.error('Something went wrong:', e?.response?.data)
      const detail = e?.response?.data?.error || e?.response?.data?.detail
      showError(detail || t('forgotPassword.toast.error'))
    } finally {
      reset()
    }
  }

  const backToLogin = () => {
    navigate('/login')
  }
  return (
    <UnauthorizedLayout
      title={t('forgotPassword.title')}
      subtitle={t('forgotPassword.subtitle')}
      question={t('forgotPassword.question')}
      text={t('forgotPassword.backLink')}
      hancleClick={backToLogin}
    >
      <div className="w-[100%] desktop:w-[500px] flex flex-col gap-4">
        <form
          className="mt-6 flex flex-col gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          <FormInput
            label={t('labels.email')}
            name="email"
            type="text"
            placeholder={t('placeholders.email')}
            register={register}
            validationRules={{
              required: t('validation.emailRequired'),
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: t('validation.emailInvalid'),
              },
            }}
            errors={errors}
          />
          <FormButton
            isSubmitting={isSubmitting}
            text={t('forgotPassword.button')}
          />
        </form>
      </div>
    </UnauthorizedLayout>
  )
}

export default ForgotPassword
